import { DynamicFieldsetModule } from '@common/forms/frontend-shared';
import { InputPasswordRepeatedInstruction, InputTextInstruction, LayoutPanelInstruction } from '@common/instructions/frontend-shared';
import { MembershipDisplayMode, MembershipRegistrationPluginFormComponent } from '@common/membership/frontend-shared';
import { AppMessagesComponent } from '@common/messages/frontend-shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiGridComponent } from '@common/ui/frontend-shared/grid';
import { UiIconsModule } from '@common/ui/frontend-shared/icons';
import { UiInputGroupComponent } from '@common/ui/frontend-shared/input-group';
import { CoreFrontendSharedModule, LocalMessageHandlerService } from '@core/frontend-shared';
import { MembershipRegistrationDataMpfPaymentModel } from '@mpf/membership-plugin-payment/shared';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../common/forms/frontend-shared/src/lib/simple-fieldset/simple-fieldset.component";
import * as i2 from "../../../../../../common/forms/frontend-shared/src/lib/form-submit-button/form-submit-button.directive";
import * as i3 from "../../../../../../common/ui/frontend-shared/src/lib/icons/icon.component";
const _c0 = a0 => ({
  label: a0
});
function MembershipRegistrationFormMpfPaymentComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.pluginTitle);
  }
}
function MembershipRegistrationFormMpfPaymentComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵconditionalCreate(1, MembershipRegistrationFormMpfPaymentComponent_Conditional_0_Conditional_1_Template, 2, 1, "h2");
    i0.ɵɵelementStart(2, "div", 6)(3, "div", 7)(4, "p");
    i0.ɵɵtext(5, "Sie erhalten:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ul", 8)(7, "li");
    i0.ɵɵelement(8, "ui-icon", 9);
    i0.ɵɵtext(9, " Zugang zu allen Kursen - stets auf dem neuesten Stand");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "li");
    i0.ɵɵelement(11, "ui-icon", 9);
    i0.ɵɵtext(12, " Zugang zu den Pr\u00FCfungen - testen Sie Ihr Wissen!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "li");
    i0.ɵɵelement(14, "ui-icon", 9);
    i0.ɵɵtext(15, " Zertifikate - digital & druckbar");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "li");
    i0.ɵɵelement(17, "ui-icon", 9);
    i0.ɵɵtext(18, " Fortbildungspunkte - anerkannt von der RbP");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "li");
    i0.ɵɵelement(20, "ui-icon", 9);
    i0.ɵɵtext(21, " 365 Tage Zugriff");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "div", 10);
    i0.ɵɵelement(23, "img", 11)(24, "img", 12)(25, "img", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "div", 7)(27, "h2", 14);
    i0.ɵɵtext(28, "8 \u20AC / Monat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "p");
    i0.ɵɵtext(30, "(Einmalzahlung - 96 \u20AC Jahresbeitrag)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "p");
    i0.ɵɵtext(32, "Die Mitgliedschaft verl\u00E4ngert sich ");
    i0.ɵɵelementStart(33, "b");
    i0.ɵɵtext(34, "nicht");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(35, " automatisch, sodass Ihnen keine Folgekosten entstehen.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "p");
    i0.ɵɵtext(37, "F\u00FCr die Zahlung ist ein PayPal-Konto oder eine Kreditkarte erforderlich.");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.displayMode === "full" ? 1 : -1);
  }
}
function MembershipRegistrationFormMpfPaymentComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function MembershipRegistrationFormMpfPaymentComponent_Conditional_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onReset());
    });
    i0.ɵɵelementEnd();
  }
}
export let MembershipRegistrationFormMpfPaymentComponent = /*#__PURE__*/(() => {
  class MembershipRegistrationFormMpfPaymentComponent extends MembershipRegistrationPluginFormComponent {
    getInstructions() {
      const compactLayout = this.displayMode === MembershipDisplayMode.compact;
      const labelProp = compactLayout ? 'placeholder' : 'label';
      const instructions = [];
      if (this.requireAccountData) {
        const checkboxInfoText = "Ich bin damit einverstanden, dass meine personenbezogenen Daten gemäß den Datenschutzbestimmungen an Drittanbieter weitergegeben werden dürfen, um weitere Informationen zu Versorgungsthemen zu erhalten.";
        instructions.push(new LayoutPanelInstruction({
          title: 'Ihr Account',
          instructions: [new InputTextInstruction({
            formControlName: 'email',
            [labelProp]: this.plugin.getLabelForField('email')
          }), new InputPasswordRepeatedInstruction({
            formControlName1: 'password',
            formControlName2: 'password2',
            [labelProp]: this.plugin.getLabelForField('password')
          }), new InputTextInstruction({
            formControlName: 'phone',
            [labelProp]: this.plugin.getLabelForField('phone')
          })
          // new InputCheckboxInstruction({ 
          // 	formControlName:'allow3rdPartyContact', 
          // 	[labelProp]:compactLayout ? undefined : this.plugin.getLabelForField('allow3rdPartyContact'), 
          // 	infoText:checkboxInfoText
          // })
          ]
        }));
      }
      instructions.push(new LayoutPanelInstruction({
        title: 'Rechnungsanschrift',
        instructions: [
        // TODO: name is part of user item and not needed when re-subscribing.
        // need to figure out if these should be separated from UserItem.
        // ...(this.requireAccountData ? [
        new InputTextInstruction({
          formControlName: 'firstName',
          [labelProp]: this.plugin.getLabelForField('firstName')
        }), new InputTextInstruction({
          formControlName: 'lastName',
          [labelProp]: this.plugin.getLabelForField('lastName')
        }),
        // ] : []),
        new InputTextInstruction({
          formControlName: 'address',
          [labelProp]: this.plugin.getLabelForField('address')
        }), new InputTextInstruction({
          formControlName: 'zipcode',
          [labelProp]: this.plugin.getLabelForField('zipcode')
        }), new InputTextInstruction({
          formControlName: 'city',
          [labelProp]: this.plugin.getLabelForField('city')
        })]
      }));
      return instructions;
    }
    getEditorDefinition() {
      return this.requireAccountData ? 'with-account-fields' : 'default';
    }
    getFormModel() {
      return MembershipRegistrationDataMpfPaymentModel;
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMembershipRegistrationFormMpfPaymentComponent_BaseFactory;
        return function MembershipRegistrationFormMpfPaymentComponent_Factory(__ngFactoryType__) {
          return (ɵMembershipRegistrationFormMpfPaymentComponent_BaseFactory || (ɵMembershipRegistrationFormMpfPaymentComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MembershipRegistrationFormMpfPaymentComponent)))(__ngFactoryType__ || MembershipRegistrationFormMpfPaymentComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MembershipRegistrationFormMpfPaymentComponent,
        selectors: [["membership-registration-form-mpf-payment"]],
        features: [i0.ɵɵProvidersFeature([LocalMessageHandlerService]), i0.ɵɵInheritDefinitionFeature],
        decls: 8,
        vars: 8,
        consts: [[1, "ui-margin", "info-section", "box-primary-dark"], [3, "formService", "instructions"], [1, "ui-margin", "ui-align-center"], ["uiButton", "", "label", "Zur\u00FCcksetzen", "icon", "times", 1, "ui-button-grey", "small"], ["uiButton", "", 1, "ui-button-primary", 3, "formSubmitButton", "formSubmitButtonOptions"], [1, "reset-wrapper"], ["uiGrid", ""], [1, "p-col-12", "p-md-6"], [1, "ui-iconlist"], ["icon", "check"], [1, "badges"], ["width", "120", "src", "https://res.cloudinary.com/meinpflegeforum/image/upload/v1706786801/meinpflegeforum/media/rbp-registrierung-beruflich-pflegender-logo.jpg", 1, "badge"], ["width", "120", "src", "https://res.cloudinary.com/meinpflegeforum/image/upload/v1706786801/meinpflegeforum/media/siegel-dsgvo-konform.svg", 1, "badge"], ["width", "65", "src", "https://res.cloudinary.com/meinpflegeforum/image/upload/v1706786801/meinpflegeforum/media/siegel-gepruefte-qualitaet.svg", 1, "badge"], [1, "pricing"], ["uiButton", "", "label", "Zur\u00FCcksetzen", "icon", "times", 1, "ui-button-grey", "small", 3, "click"]],
        template: function MembershipRegistrationFormMpfPaymentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, MembershipRegistrationFormMpfPaymentComponent_Conditional_0_Template, 38, 1, "div", 0);
            i0.ɵɵelement(1, "simple-fieldset", 1)(2, "app-messages");
            i0.ɵɵelementStart(3, "div", 2)(4, "ui-input-group");
            i0.ɵɵconditionalCreate(5, MembershipRegistrationFormMpfPaymentComponent_Conditional_5_Template, 1, 0, "button", 3);
            i0.ɵɵelement(6, "button", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(7, "div", 5);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.platform === "frontend" ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formService", ctx.formService)("instructions", ctx.instructions);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.platform === "frontend" ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formSubmitButton", ctx.formService)("formSubmitButtonOptions", i0.ɵɵpureFunction1(6, _c0, !ctx.submitsImmediately ? "weiter" : "senden"));
          }
        },
        dependencies: [CoreFrontendSharedModule, UiGridComponent, DynamicFieldsetModule, i1.SimpleFieldsetComponent, i2.FormSubmitButtonDirective, UiButtonComponent, UiInputGroupComponent, AppMessagesComponent, UiIconsModule, i3.UiIconComponent],
        styles: [".pricing[_ngcontent-%COMP%]{color:var(--primaryColor);font-size:3rem;font-weight:700;margin:0!important}.pricing[_ngcontent-%COMP%] + p[_ngcontent-%COMP%]{margin-top:0}.badges[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:center;width:600px;max-width:100%;margin:30px auto;border-radius:5px;flex-wrap:wrap}.badge[_ngcontent-%COMP%] + .badge[_ngcontent-%COMP%]{margin-left:5px}.info-section[_ngcontent-%COMP%]{margin:-20px -20px 24px;padding:20px}\n\n/*# sourceMappingURL=registration-form.component.ts-angular-inline--63.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return MembershipRegistrationFormMpfPaymentComponent;
})();